import { Avatar, Flex, UnstyledButton, useMantineTheme } from '@mantine/core'

import type { UserItemProps } from '@/modules/advisors/users/pages/chat/components/UserItem/UserItem.types'

import { Text } from '@/components/Text/Text'

import classes from './UserItem.module.css'

export function UserItem({ onUserSelect, selected, user }: UserItemProps) {
  const theme = useMantineTheme()

  if (!user) return null

  const displayName = `${user.firstName} ${user.lastName}`

  return (
    <UnstyledButton onClick={() => onUserSelect(user.id)} w="100%">
      <Flex className={`${classes.container} ${selected && classes.selected}`}>
        <Avatar
          alt={displayName}
          color={theme.other.colors.grey}
          mr={8}
          src={user.avatar}
        />

        <Text
          c={selected ? theme.other.colors.white : theme.other.colors.black}
        >
          {displayName}
        </Text>
      </Flex>
    </UnstyledButton>
  )
}
